import React, { Component } from "react"
import styled, { keyframes } from "styled-components"

const opacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const load2 = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const Loader = styled.div`
  opacity: 0;
  animation: ${opacity} 2s ease forwards;
  animation-delay: 400ms;
  border-radius: 50%;
  &:before,
  :after {
    border-radius: 50%;
    position: absolute;
    content: "";
  }
  &:before {
    width: 16px;
    height: 32px;
    background-color: inherit;
    border-radius: 32px 0 0 32px;
    top: -1px;
    left: -1px;
    transform-origin: 16px 16px;
    animation: ${load2} 2s infinite ease 1.5s;
  }

  color: #ffffff;
  background-color: white;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 30px;
  height: 30px;
  box-shadow: inset 0 0 0 1px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);

  &:after {
    width: 16px;
    height: 32px;
    background-color: inherit;
    border-radius: 0 32px 32px 0;
    top: -1px;
    left: 15px;
    -webkit-transform-origin: 0px 16px;
    transform-origin: 0px 16px;
    -webkit-animation: load2 2s infinite ease;
    animation: ${load2} 2s infinite ease;
  }
`

export default class DonutLoader extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Loader
        style={{
          color: this.props.color,
          backgroundColor: this.props.backgroundColor
        }}
      />
    )
  }
}
